<template>
  <!-- class="bggray2" style="padding: 15px; border-radius: 8px" -->
  <div>
    <el-row class="" style="padding: 15px; border-radius: 8px; margin-bottom: 5px;background:#EDF2F5">
      <el-col :span="24">
        <el-row :gutter="10">
          <el-col :span="6">
            <div class="fl" style="width: 65px">
              <el-avatar :size="50" :src="circleUrl"></el-avatar>
            </div>
            <div style="border-right:1px solid #eee;margin-top:6px">
              <p class="fb">姓名：{{userInfo.name}}</p>
              <p>
                部门/学院：{{userInfo.department}}
              </p>

            </div>
          </el-col>
          <el-col :span="6">
            <div style="margin-left:10px;border-right:1px solid #eee;margin-top:6px">
              <p>班级：{{userInfo.bj}}</p>
              <p>学号/工号：{{userInfo.userid}}</p>

            </div>
          </el-col>
          <el-col :span="6">
            <div style="margin-left:10px;border-right:1px solid #eee;margin-top:6px">
              <p>
                <i class="el-icon-message-solid forange"></i> 消息通知： <span
                  class="fb forange">{{count.messageCount}}</span>条
              </p>
              <p> <i class="el-icon-s-order fblue"></i> 申请事项： <span class="fred">{{count.applyCount}}</span>次</p>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="margin-left:10px;margin-top:6px">
              <p><i class="el-icon-s-order fgreen2"></i> 成功办结：<span class="fgreen2">{{count.successCount}}</span>次</p>
              <p><i class="el-icon-s-order fblue"></i> 节省时间：<span class="fblue">{{count.saveDay}}</span>天</p>
            </div>
          </el-col>
        </el-row>

      </el-col>
      <!-- <el-col :span="22">张三</el-col> -->
    </el-row>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix tc">
            <span>全部事项</span>
          </div>
          <div v-if="allService.length!=0">
            <div class="text item" v-for="item in allService" :key="item.SERVICE_ID">
            <el-image style="width: 60px; height: 60px; float: left" :src="url" fit="fill"></el-image>
            <div class="flex-col v-center pl8" style="height: 60px">
              {{item.SERVICE_NAME}}（{{item.CNT_ALL}}）
            </div>
          </div>
          </div>
        
        <div v-else class="f_gray tc" style=" min-height: 50vh;margin-top:40px;" >暂无数据</div>

        </el-card>
      </el-col>
      <el-col :span="19">
        <el-row class="status" style="padding:10px 10px 10px 20px; ">
          <el-col :span="6" :class="isSelect==0?'activelink':''" @click.native="changeSelect(0)"><i
              class="el-icon-edit"></i>待办理</el-col>
          <el-col :span="6" :class="isSelect==1?'activelink':''" @click.native="changeSelect(1)"><i
              class="el-icon-chat-round"></i>待评价</el-col>
          <el-col :span="6" :class="isSelect==2?'activelink':''" @click.native="changeSelect(2)"><i
              class="el-icon-chat-line-round"></i>已评价</el-col>
          <el-col :span="6" :class="isSelect==3?'activelink':''" @click.native="changeSelect(3)"><i
              class="el-icon-s-grid"></i>全部</el-col>
        </el-row>
        <div style=" min-height: 50vh;"   v-if="serviceByState.length!=0">
          <el-row style="padding:10px 10px 10px 20px; border-bottom: 1px dotted #ccc"
          v-for="item in serviceByState"
            :key="item.id">
            <el-col :span="22">
              <p class="fb">{{item.f1}}</p>
              <p>申请时间:{{item.applyTime}}</p>
              <p>办结时间:{{item.finishTime}}</p>
              <p>当前状态：{{item.runState==0?'办理中':(item.runState==1?'待评价':'已评价')}}</p>
            </el-col>
            <el-col :span="2">
              <div class="flex-col h-center" style="height: 80px">
                <el-link :underline="false" type="primary">查看详情</el-link>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else class="f_gray tc" style=" min-height: 50vh;margin-top:40px;" >暂无数据</div>

        <el-pagination style="margin-top:20px" background layout="prev, pager, next" :total="total"
          :page-size="pageSize" @current-change="handleCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import "../static/css/my.css";
import { mapGetters } from 'vuex'
import moment from 'moment'
import { queryMyHomePageStat, queryServiceRun,queryUserInfoByUserid } from '@/api/myHome'
export default {
  name: "myHome",
  data() {
    return {
      circleUrl:
        "",

      url: "",
      allService: [], //全部事项列表
      serviceByState: [],//办理列表
      count: {
        messageCount: 0,
        successCount: 0,
        applyCount: 0,
        saveDay: 0,
      },
      isSelect: 0,//选中状态 0=待办理 1=待评价 2=已评价
      total: 0,
      pageIndex: 1,
      pageSize: 4,
      userInfo: {}
    };
  },
  computed: {
    ...mapGetters(['getUserId','getUserInfo'])
  },
  mounted() {
    this.userInfo=JSON.parse(this.getUserInfo)
    this.getMyHomePageStat()
    this.getServiceRun()
  },
  methods: {
    async getUserInfoByUserid() {
      const data = await queryUserInfoByUserid(this.getUserId)
      console.log(data)
      if (data.status == 200) {
        this.userInfo = data.data.data
        console.log(this.userInfo)
      }
    },
    async getMyHomePageStat() {
      const data = await queryMyHomePageStat()
      if (data.msgCode == 0) {
        this.allService = data.data
        console.log(this.allService)
        if (this.allService == null) {
          return
        }
        this.allService.forEach(item => {
          this.count.successCount += item.CNT_SUCCESS
          this.count.applyCount += item.CNT_ALL

        })
      }
    },
    async getServiceRun() {
      let searchData = [
        {
          name: 'eq_runState',
          value: this.isSelect == 3 ? '' : this.isSelect
        }, {
          name: 'eq_applyUserid',
          value: this.getUserId
        }
      ]
      let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize

      }
      const data = await queryServiceRun(params)
      if (data.msgCode == 0) {
        console.log(data)
        if (data.data == null) {
          return
        }
        data.data.forEach(item => {
          if (item.applyTime != null)
            item.applyTime = moment(item.applyTime).format("YYYY-MM-DD HH:mm:ss")
          if (item.finishTime != null)
            item.finishTime = moment(item.finishTime).format("YYYY-MM-DD HH:mm:ss")
        })

        this.serviceByState = data.data
        this.total = data.total
      }
    },
    changeSelect(state) {
      this.isSelect = state
      this.getServiceRun()
    },
    handleCurrentChange(val) {
      console.log(val)
      this.pageIndex = val
      this.getServiceRun()
    }
  },
  components: {
    // HelloWorld
  },
};
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 8px;
  border-bottom: 1px dotted #ccc;
  padding-bottom: 8px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

/* .el-card__header {
  padding: 10px 5px !important;
  background: #00881f;
  color: #fff;
  font-weight: bold;
} */

.status {
  cursor: pointer;
  background: #ecfff5;
  font-size: 14px;
  border-radius: 5px;
}

.activelink {
  color: #00881f;
  font-weight: bold;
}


</style>